import { useQuery } from '@tanstack/react-query'
import { tagsKeys } from '@/api/queryKeys'
import { fetchTags } from '@/api/tags'

/**
 * Hook to fetch all tags with optional filters
 *
 * @param params - Query parameters for filtering
 * @returns React Query result with tags list data
 *
 * @example
 * ```tsx
 * const { data, isLoading, error } = useTagsList({ searchText: 'guard', limit: 20 });
 * ```
 */
export function useTagsList(params?: {
  searchText?: string
  limit?: number
  offset?: number
  includeRelations?: boolean
}) {
  return useQuery({
    queryKey: tagsKeys.list(params ?? {}),
    queryFn: () => fetchTags(params ?? {}),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
